module.exports = __webpack_public_path__ + "static/media/account.a52980b6.svg";